module.exports = __webpack_public_path__ + "img/f.5aa43cd3.png";